import { render, staticRenderFns } from "./lockpassWord.vue?vue&type=template&id=6c3c2d88&scoped=true"
import script from "./lockpassWord.vue?vue&type=script&lang=js"
export * from "./lockpassWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3c2d88",
  null
  
)

export default component.exports